// NOTE: this package doesn't actually include express. Just its types so we can
// share a critical piece of functionality.
import type { Request } from "express";

type QueryStringSubType = Request["query"];
type QueryStringArgumentType =
  | string
  | string[]
  | QueryStringSubType
  | QueryStringSubType[]
  | undefined;

/**
 * Given an unknown querystring type, this function will return a stringified version of it,
 * if it exists, otherwise, returns undefined. With multiple arguments, we will return the
 * first result that is not undefined. Otherwise, we will return undefined.
 *
 * @param qs query string-like variable from the request
 */
export function queryStringValueToStringOrUndefined(
  ...qs: QueryStringArgumentType[]
): string | undefined {
  for (const query of qs) {
    const type = typeof query;
    if (type !== "string" && type !== "number" && type !== "boolean") {
      continue;
    }

    return String(query);
  }

  return undefined;
}
